const fileNameStyle =
  'flex overflow-hidden whitespace-nowrap m-0 text-base text-[#B6C2CF]';

const FileName = ({ name = '' }: { name: string }) => {
  if (name.length < 8) {
    return (
      <p className={fileNameStyle}>
        <span>{name}</span>
      </p>
    );
  }

  const splitIndex = name.length - 7;
  const result = [name.slice(0, splitIndex), name.slice(splitIndex)];

  return (
    <p className={fileNameStyle}>
      <span className="inline-block overflow-hidden text-ellipsis whitespace-nowrap align-bottom">
        {result[0]}
      </span>
      <span className="relative inline-block flex-[1_0_auto] overflow-hidden whitespace-nowrap align-bottom">
        {result[1]}
      </span>
    </p>
  );
};

export default FileName;
